// import { createContext, useState, useContext } from 'react';

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isAdmin, setIsAdmin] = useState(false);

//   const login = (email, password, isAdminLogin = false) => {
//     // In a real app, this would call your authentication API
//     if ((email === 'user@example.com' && password === 'user123') || 
//         (email === 'admin@example.com' && password === 'admin123')) {
      
//       const userData = {
//         email,
//         name: isAdminLogin ? 'Admin User' : 'Regular User',
//         token: 'fake-jwt-token'
//       };
      
//       setUser(userData);
//       setIsAdmin(isAdminLogin);
//       return true;
//     }
//     return false;
//   };

//   const logout = () => {
//     setUser(null);
//     setIsAdmin(false);
//   };

//   return (
//     <AuthContext.Provider value={{ user, isAdmin, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  // Load user from localStorage on mount (for persistence)
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedIsAdmin = localStorage.getItem('isAdmin');
    const storedToken = localStorage.getItem('token');

    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
      setIsAdmin(storedIsAdmin === 'true');
    }
    setLoading(false);
  }, []);

  const login = async (email, password, isAdminLogin = false) => {
    try {
      const url = isAdminLogin
        ? 'https://saloonbackend.dockyardsoftware.com/api/AdminAuth/login'
        : 'https://saloonbackend.dockyardsoftware.com/api/Auth/login'; // Adjust user login endpoint
 
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid email or password');
      }

      const data = await response.json();

      // You should get token and user info from the response, adjust accordingly
      const userData = {
        email,
        name: isAdminLogin ? 'Admin User' : 'Regular User',
      };

      setUser(userData);
      setIsAdmin(isAdminLogin);

      // Save to localStorage
      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('isAdmin', isAdminLogin ? 'true' : 'false');
      localStorage.setItem('token', data.token);

      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const signup = async (formData) => {
    // Implement real signup API call here if you want
    await new Promise((resolve) => setTimeout(resolve, 1500));
    return true;
  };

  const logout = () => {
    setUser(null);
    setIsAdmin(false);
    localStorage.removeItem('user');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, isAdmin, login, signup, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
